// Horse
export { GaitNumbers } from './horse/gait-numbers';
